import { useEffect, useState } from 'react';

interface UseUploadWithExistingOptions {
  value: File | null;
  existingUrl: string | null;
  onRemoveExisting?: () => void;
}

interface UseUploadWithExistingResult {
  showExisting: boolean;
  handleRemoveExisting: () => void;
}

export function useUploadWithExisting({
  value,
  existingUrl,
  onRemoveExisting,
}: UseUploadWithExistingOptions): UseUploadWithExistingResult {
  const [showExisting, setShowExisting] = useState(!!existingUrl && !value);

  useEffect(() => {
    if (value) {
      setShowExisting(false);
    }
  }, [value]);

  const handleRemoveExisting = () => {
    setShowExisting(false);
    onRemoveExisting?.();
  };

  return {
    showExisting,
    handleRemoveExisting,
  };
}
